import { createContext } from 'react'

// Separate from the public theme API: only route boundaries can replace tenant context.
export const BrandingScopeContext = createContext(null)
